import React from 'react';
import { getComputedCSSVariable } from '../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const FemaleSVG: React.FC<Props> = ({
  color,
}) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M13.1329 2.8756C11.088 0.81939 7.7731 0.8193 5.72808 2.87533C5.24109 3.36394 4.85489 3.94452 4.59168 4.5837C4.32854 5.22273 4.19351 5.90861 4.19434 6.60027C4.19359 7.2919 4.32865 7.97599 4.59179 8.61499C4.76412 9.03349 4.98916 9.42688 5.26069 9.78579L4.3015 10.7505L2.68168 9.12138C2.42608 8.86432 2.01167 8.86432 1.75607 9.12138C1.50047 9.37844 1.50047 9.79521 1.75607 10.0523L3.3759 11.6813L1.52471 13.5431C1.26911 13.8002 1.26911 14.2169 1.52471 14.474C1.78031 14.7311 2.19471 14.7311 2.45031 14.474L4.3015 12.6122L5.92133 14.2413C6.17692 14.4984 6.59133 14.4984 6.84693 14.2413C7.10253 13.9842 7.10253 13.5675 6.84693 13.3104L5.22711 11.6813L6.17686 10.7262C8.23245 12.3693 11.2316 12.2349 13.1329 10.3231C15.1775 8.26646 15.1775 4.93227 13.1329 2.8756ZM6.65333 3.80657C8.18712 2.26431 10.6735 2.26428 12.2073 3.80649C13.7408 5.34903 13.7408 7.84958 12.2074 9.39216C10.6736 10.9344 8.18712 10.9344 6.65333 9.39216L6.65285 9.39167C6.28788 9.02545 5.99845 8.59032 5.80118 8.11127C5.60391 7.63222 5.5027 7.1187 5.50335 6.60019L5.50334 6.59846C5.50263 6.07997 5.60382 5.56645 5.80108 5.08742C5.99834 4.60838 6.28779 4.17328 6.65279 3.80711L6.65333 3.80657Z" fill={`${color}`} />
    </svg>
  );
};

FemaleSVG.defaultProps = {
  color: getComputedCSSVariable('label-gray'),
};

export default FemaleSVG;
